// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { EnumRequisitionStatus } from '@Model';
import {
    EnumFilterExpressionOperation,
    EnumOperation,
    type FilterCondition,
    type FilterExpression,
    type RadioCardOption,
} from '@synqo/frontend-component-library';

export type PortalRequisitionFilter = 'all' | 'open' | 'inProgress' | 'completed';

/** Coarser than the ERP status filter on purpose: still coming, running, or done. */
export const portalRequisitionFilterOptions: RadioCardOption<PortalRequisitionFilter>[] = [
    { value: 'all', title: 'Alle' },
    { value: 'open', title: 'Offen' },
    { value: 'inProgress', title: 'In Bearbeitung' },
    { value: 'completed', title: 'Abgeschlossen' },
];

function statusIs(status: EnumRequisitionStatus): FilterCondition {
    return { field: 'ProcessState', value: String(status), operator: EnumOperation.Equal };
}

function anyOf(...statuses: EnumRequisitionStatus[]): FilterExpression {
    return {
        operation: EnumFilterExpressionOperation.Or,
        filters: statuses.map(statusIs),
    };
}

/** Server-side filter for the selected quick filter, or undefined for "Alle". */
export function getPortalRequisitionFilterExpression(filter: PortalRequisitionFilter): FilterExpression | undefined {
    switch (filter) {
        // "Offen" covers everything that has arrived but is not being executed yet.
        case 'open':
            return anyOf(EnumRequisitionStatus.Open, EnumRequisitionStatus.UnderReview);
        case 'inProgress':
            return anyOf(EnumRequisitionStatus.InProgress);
        case 'completed':
            return anyOf(EnumRequisitionStatus.Completed);
        default:
            return undefined;
    }
}
